'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var contactInformation = {
    ADDRESS: (0, _reactIntl.defineMessages)({
        NO_HOME_ADDRESS: {
            'id': 'formOverrides.contactInformation.NO_HOME_ADDRESS',
            'defaultMessage': 'I do not wish to provide my home address.'
        }
    }),
    EMAIL_ADDRESS: (0, _reactIntl.defineMessages)({
        NO_PTE_EMAIL: {
            'id': 'formOverrides.contactInformation.NO_PTE_EMAIL',
            'defaultMessage': 'I do not wish to provide my email address.'
        }
    }),
    PHONE_NUMBERS: (0, _reactIntl.defineMessages)({
        NO_PHONE: {
            'id': 'formOverrides.contactInformation.NO_PHONE',
            'defaultMessage': 'I do not wish to provide a phone number.'
        }
    })
};

exports.default = contactInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/contactInformation.js
// module id = 1380
// module chunks = 0